import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from "react-redux";

import ModalCTA from '../modal/ModalCTA';
import AddPlaylist from '../form/AddPlaylist';
import IconAdd from './svg/IconAdd';

import { setModal } from "../../../actions/index";

function AddPlaylistButton() {
  const playlistAutomix = useSelector( state => state.playlistAutomix );
  const isConnected = useSelector( state => state.isConnected)
  const storePopup = useSelector( state => state.storePopup)
  const dispatch = useDispatch();

  const addToPlaylist = (e) => {
    if (playlistAutomix && playlistAutomix.tracks) {
      const track = playlistAutomix.tracks[playlistAutomix.active];
      if (isConnected) {
        dispatch(setModal({ // V2
          content: (
            <ModalCTA
              title={`Select a playlist`}
              styleContainer={{marginTop: `-30%`, marginLeft: `0%`}}
              styleBody={{gap: 32}}
            >
              <AddPlaylist data={[track]} />
            </ModalCTA>
          )
        }));
      } else {
        storePopup.playlist();
      }
    }
  }

  return (
    <div className={`align`} onClick={addToPlaylist} >
      <IconAdd size={24} color={Config.TYPE_SECONDARY} className={`cf-icon-fill-v2`} />
    </div>
  )
}

AddPlaylistButton.propTypes = {
  showAddCart: PropTypes.bool
}

export default AddPlaylistButton;
